import axios from "axios";
import Logger from "../../utils/Logger";
import store from "../../store";
import {BASE_URL_API} from "../../utils/Config";

const apiVersion = 4

const createAxios = () => {
    return axios.create({
        baseURL: BASE_URL_API,
        headers: localStorage.getItem("user") ? {
            'Api-Version': apiVersion,
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem("user")).token,
        } : {
            'Api-Version': apiVersion,
            'Content-Type': 'application/json',
        }
    })
}

let Axios = createAxios()

export function _post(url, data) {
    Logger.d("API POST " + url + " with data : ")
    Logger.d(data)

    store.commit('global/addLoadingQueue')

    return Axios.post(url, data, {
        validateStatus: function (status) {
            return true
        }
    })
        .then(r => {
            return parse(r, "POST " + url)
        })
        .finally(() => {
            store.commit('global/removeLoadingQueue')
        })
}

export function _put(url, data) {
    Logger.d("API PUT " + url + " with data : ")
    Logger.d(data)

    store.commit('global/addLoadingQueue')

    return Axios.put(url, data, {
        validateStatus: function (status) {
            return true
        }
    })
        .then(r => {
            return parse(r, "PUT " + url)
        })
        .finally(() => {
            store.commit('global/removeLoadingQueue')
        })
}

export function _get(url) {
    Logger.d("API GET " + url)

    store.commit('global/addLoadingQueue')

    return Axios.get(url, {
        validateStatus: function (status) {
            return true
        }
    }).then(r => {
        return parse(r, "GET " + url)
    })
        .finally(() => {
            store.commit('global/removeLoadingQueue')
        })
}

export function _delete(url, data) {
    Logger.d("API DELETE " + url)

    store.commit('global/addLoadingQueue')

    return Axios.delete(url, {
        data: data,
        validateStatus: function (status) {
            return true
        }
    }).then(r => {
        return parse(r, "DELETE " + url)
    })
        .finally(() => {
            store.commit('global/removeLoadingQueue')
        })
}

function parse(r, text) {
    if (r.data.status != 200) {
        Logger.e("Error dari API : " + text)
        Logger.e(r.data)
        Logger.e(r.data.message)

        if (r.data.status == 410)
            location.reload()

        throw r.data
    }
    else {
        Logger.i("Success dari API " + text)
        Logger.i(JSON.parse(JSON.stringify(r.data)))
    }

    return r.data.data
}

export function reloadAxios() {
    Axios = createAxios()
}

export default Axios
